import AppLayout from "@/layouts/AppLayout";
import PageHeading from "@/components/PageHeading";
import PeopleTabs from "./_components/PeopleTabs";
import { useCanViewOperationsTabBool } from "@/hooks/useCapabilities";

export default function TabLayout({ children }: { children: React.ReactNode }) {
  const showTabs = useCanViewOperationsTabBool();

  return (
    <AppLayout>
      {showTabs && <PageHeading title="People" />}
      <PeopleTabs />
      <div className="flex flex-col">{children}</div>
    </AppLayout>
  );
}
